import { ReceiptState, ReceiptStateValue } from '@interfaces/receipts';
import { Source } from '@interfaces/source';

type Params = {
  receiptState: ReceiptState | undefined | null;
  source: Source;
};
export function checkReceiptsLimit({ receiptState, source }: Params) {
  const sourceState = receiptState?.source[source];
  return !!sourceState && sourceState.state !== ReceiptStateValue.limit;
}
